function EmptyWidget({ widgetStyles, blankText, emptyState = <></>, isNotManagable }) {
    return widgetStyles && widgetStyles?.translations?.blank ? <div className="tb-widget-empty">
        <span>{blankText || widgetStyles?.translations?.blank}</span>
        {isNotManagable ? <></> :
        <div onClick={widgetStyles?.cb}>
            <i className="digi_icon-edit"></i>
            <span>{widgetStyles?.translations?.addContent}</span>
        </div>}
    </div> : emptyState
}

export default EmptyWidget;